import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { useDocumentTitle } from '@/shared/lib/use-document-title';
import { rememberPendingEmail } from '../../features/auth/pending-email';
import { SignInForm } from '../../features/auth/sign-in-form';
import { supabase } from '../../shared/api/supabase';
import { AuthLayout } from '../../shared/ui/auth-layout';

export function SignInPage() {
  const { t } = useTranslation('auth');
  useDocumentTitle(t('signIn.title'));
  const navigate = useNavigate();
  // Where to go afterwards (the invite page sends people here). Same-site paths only: `/x`, never `//host`.
  const next = useSearchParams()[0].get('next');
  const target = next && /^\/(?!\/)/.test(next) ? next : '/';
  return (
    <AuthLayout
      title={t('signIn.title')}
      footer={
        <p>
          {t('signIn.noAccount')} <Link to="/sign-up">{t('signIn.createOne')}</Link>
        </p>
      }
    >
      <SignInForm
        onSubmit={async (values) => {
          const { error } = await supabase.auth.signInWithPassword(values);
          if (error?.code === 'email_not_confirmed') {
            rememberPendingEmail(values.email);
            navigate('/check-email');
            return { error: null };
          }
          if (error) return { error: error.message };
          navigate(target);
          return { error: null };
        }}
      />
    </AuthLayout>
  );
}
